var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-base',{attrs:{"title":"Available field types","items":_vm.fqt,"key-name":'fqt_name'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('icon',{staticClass:"mr-1",attrs:{"icon":item.icon}}),_vm._v(_vm._s(item.fqt_displayname)+"\n    ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }